import React from 'react';

import './FourOFour.css';

const ForOFour = () => (
  <div className="error-page">
    <div>
      <h1 data-h1="404">404</h1>
      <p data-p="NOT FOUND">NOT FOUND</p>
    </div>
  </div>
);

export default ForOFour;
